import React from "react";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import {
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Badge,
} from "@mui/material";
import { Image } from "cloudinary-react";
import { styled } from "@mui/material/styles";
import { magnets } from "./defaults";
import useMagnetCatchSelector from "./useMagnetCatchSelector";
import { ColLayout } from "../../util/accordianStyles";
import { useIsReadOnlyContextProviderContext } from "../../context/IsReadOnlyContext";
import PleaseNote from "../PleaseNote";

const StyledDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  paddingTop: 10,
});

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  margin: theme.spacing(1),
  width: 200,
}));

const StyledBadge = styled(Badge)({
  "& .MuiBadge-badge": {
    backgroundColor: "#f0be07",
  },
});

const MagnetCatchAccordian = () => {
  const {
    handleClick,
    handleChangeColor,
    checkMark,
    variant,
    imgSrc,
    magnetCatchColor,
    colorOptions,
    open,
    handleOpen,
    handleClose,
  } = useMagnetCatchSelector();
  const { readOnly } = useIsReadOnlyContextProviderContext();

  return (
    <ReusableAccordian
      accordionName="magnetCatch"
      heading="Magnet"
      secondaryHeading="Select a magnet"
      colOrRow="col"
    >
      <ColLayout style={{ margin: 0, alignItems: "flex-start" }}>
        <PleaseNote notes="Comes with standard magnet catch; Centor magnet catch available as an upgrade" />
      </ColLayout>

      <StyledDiv>
        <StyledBadge badgeContent="New!">
          <div onClick={() => handleClick(magnets.label)}>
            <Choices
              label={magnets.label}
              variant={variant(magnets.label)}
              checkMark={checkMark(magnets.label)}
              disabled={readOnly}
            />
          </div>
        </StyledBadge>
      </StyledDiv>

      {colorOptions.length ? (
        <StyledDiv>
          <StyledFormControl variant="outlined">
            <InputLabel>
              Select a finish<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <Select
              style={{ width: 200, height: 50 }}
              label="Select a finish"
              value={magnetCatchColor || ""}
              onChange={handleChangeColor}
              open={open}
              onOpen={handleOpen}
              onClose={handleClose}
              disabled={readOnly}
            >
              <MenuItem value=""></MenuItem>
              {colorOptions.map((item) => (
                <MenuItem key={item.id} value={item.label}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </StyledFormControl>
        </StyledDiv>
      ) : null}

      {imgSrc && (
        <StyledDiv>
          <Image cloudName="ag-millworks" publicId={imgSrc} secure="true" />
        </StyledDiv>
      )}
    </ReusableAccordian>
  );
};

export default MagnetCatchAccordian;
